export default "__VITE_ASSET__DGMHf9$B__"